
//スクロール表示

import flatpickr from "flatpickr";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
import "flatpickr/dist/flatpickr.css";

document.addEventListener("turbolinks:load", function (e) {

    if ($('#view_consultation').length >= 0) {
        var showFlug = false;
        var topBtn = $('#page-top');
        topBtn.css('bottom', '-75px');
        var showFlug = false;
        $(window).scroll(function () {
            if ($(this).scrollTop() > 50) {
                if (showFlug == false) {
                    showFlug = true;
                    topBtn.stop().animate({'bottom' : '20px'}, 100);
                }
            } else {
                if (showFlug) {
                    showFlug = false;
                    topBtn.stop().animate({'bottom' : '-100px'}, 100);
                }
            }
        });

        //スクロールトップ
        topBtn.click(function () {
            $('body,html').animate({
                scrollTop: 0
            }, 500);
            return false;
        });

        function cat01() {
            $(this).next().slideToggle(300);
        }
        $(".simple .toggle").click(cat01);


        function cat02() {
            $(this).toggleClass("active").next().slideToggle(300);
        }
        $(".switch .toggle").click(cat02);

        $('.special_shojo').click(function() {
            console.log(this.value)
            if (this.value === 'true' || this.value === 'present') {
                $(this).closest('.cat').find('.detail').show(300);
            } else {
                $(this).closest('.cat').find('.detail').hide(300);
            }
        })

        // 腰痛健診の条件付き表示
        $('input[name="consultation[has_youtsuu_past]"]').click(function() {
            if (this.value === '1') {
                $(this).closest('.non-hover').next('.detail').show(300);
            } else {
                $(this).closest('.non-hover').next('.detail').hide(300);
            }
        })

        $('input[name="consultation[youtsuu_last_month]"]').click(function() {
            if (this.value === '1') {
                $(this).closest('.non-hover').next('.detail').show(300);
            } else {
                $(this).closest('.non-hover').next('.detail').hide(300);
            }
        })

        // 問診切り替え
        $('#btn_admin_consultation_change').click(function() {
            changeConsultation();
        })
        $(document).on("keypress", "input#admin_consultation_book_code", function(event) {
            if (event.which === 13) changeConsultation();
        })
        $(document).on("focus", "input#admin_consultation_book_code", function() {
            $(this).select();
        })
        function changeConsultation() {
            let book_code = $('#admin_consultation_book_code').val();
            // 4桁以下の場合、全角数字を半角数字に変換
            if (book_code.length <= 4) {
                book_code = book_code.replace(/[０-９]/g, function(s) {
                    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
                });
            }
            if (book_code.length === 0) {
                alert('バーコード番号を入力してください')
                return false;
            } else if (book_code.length > 4 && book_code.length !== 10 && book_code.length !== 11 && book_code.length < 12) {
                // バーコード読み込みの13桁対応するために、12桁未満のみチェックする（13桁以上はサーバーサイドで切り落とす）
                // ブレスレットが追加されたので4桁以下は許容する
                // 基幹システムは10桁
                alert('バーコード番号は数字4桁以下または10桁または12桁で入力してください')
                return false;
            }
            location.href = `/admin/consultations/barcode?book_code=${book_code}`
        }

        if ($('#form_step2').length > 0) {
            // 就業中切り替え
            $('input[name="consultation[working]"]').change(function() {
                changeWorkingDisplay($(this).val())
            })
            changeWorkingDisplay($('input[name="consultation[working]"]:checked').val());
            function changeWorkingDisplay(val) {
                if (val === undefined) {
                    $('.step2_content').hide();
                } else {
                    $('.step2_content').show();
                }
                if (val === 'true') {
                    $('.working_hearing').show();
                } else {
                    $('.working_hearing').hide();
                }
            }

            // 喫煙状況の表示切り替え（吸っている・以前吸っていたの場合のみ本数・年数を表示）
            $('input[name="consultation[life_cigarette2]"]').change(function() {
                const val = $(this).val();
                if (val === 'smoking' || val === 'before') {
                    $('#cigarette_detail').show(300);
                } else {
                    $('#cigarette_detail').hide(300);
                }
            })
        }

    }

    $('.admin_update_booked_on').click(function() {
        const id = $(this).data('id')
        $.ajax({
            type: 'POST',
            url: `/admin/consultations/${id}/admin_update`,
            data: {
                booked_on: $(this).parents('.booked_on').find('.booked_on_input').val(),
                booked_time_hour: $(this).parents('.booked_on').find('.booked_time_hour_input').val(),
                booked_time_min: $(this).parents('.booked_on').find('.booked_time_min_input').val()
            },
            dataType: 'script'
        })
    })

    $('.admin_update_booked_number').click(function() {
        const id = $(this).data('id')
        $.ajax({
            type: 'POST',
            url: `/admin/consultations/${id}/admin_update`,
            data: { booked_number: $(this).parents('.booked_number').find('.booked_number_input').val() },
            dataType: 'script'
        })
    })

    $('#consultations_all_check').change(function() {
        const checks = $('.print_id_check');
        checks.prop('checked', $(this).prop('checked'))
    })

    $('.first_answer').change(function() {
        console.log($(this).val())
        if ($(this).val() === 'true') {
            $('.detail_answer_area').show();
        } else {
            $('.detail_answer_area').hide();
        }
    })

    // 喫煙歴の表示切り替え（やめた・吸っているの場合のみ詳細を表示）
    $('input[name="consultation[jinpai_smoke_status]"]').change(function() {
        const val = $(this).val();
        if (val === 'quit' || val === 'smoking') {
            $('#smoke_detail').removeClass('d-none');
            $('#smoke_detail').addClass('d-sm-flex');
        } else {
            $('#smoke_detail').addClass('d-none');
            $('#smoke_detail').removeClass('d-sm-flex');
        }
    })

    if ($('#front_consultation_form').length > 0) {
        let preventUnload = true; // ページ離脱時の警告を管理するフラグ

        window.addEventListener("beforeunload", function (event) {
            if (preventUnload) {
                event.preventDefault();
            }
            preventUnload = true;
        });

        $('form').submit(function(event) {
            disableBeforeUnload()
        })

        function disableBeforeUnload() {
            preventUnload = false; // ページ離脱時の警告を無効化
            setTimeout(() => preventUnload = true, 1000); // 送信後、1秒後に再度有効化
        }
    }

});
